<template>
  <button v-show="!isEditingTitle"
          class="actions-dropdown icon-button"
          @click="showDropdown"
          v-t:title="'Column actions'">
    <base-icon name="more_vert" />
  </button>
</template>

<script>
import IntlMixin from 'vuemixins/intl_mixin'
import BaseIcon from 'vuecomponents/base_icon'
import { mapGetters, mapState, mapActions } from 'vuex'
import nativeBridge from 'bits/native_bridge'
const menuItemBuilder = nativeBridge.uiManifests.menuItem
export default {
  components: { BaseIcon },
  mixins: [IntlMixin],
  props: ['section'],
  computed: {
    ...mapState('section', ['sectionBeingEditedId']),
    ...mapGetters('section', {
      wallSections: 'sections'
    }),
    ...mapGetters(['canIModerate']),
    isDeletable () { /* can only delete a section that has an ID */ return this.canIModerate && !!this.section.id },
    // showIconList() { return false  /*!this.isTouchable or this.isBeingEdited */},
    isEditingTitle () { return this.sectionBeingEditedId && this.sectionBeingEditedId === this.section.id }
  },
  mounted () {
    nativeBridge.addMessageHandler('ask_to_delete',   (msg) => { nativeBridge.ui.show('alert', this.getAskToDeleteSectionManifest()) })
    nativeBridge.addMessageHandler('edit_section',    (msg) => { this.startEditingSection({ sectionId: msg.section_id }) })
    nativeBridge.addMessageHandler('delete_section',  (msg) => { this.deleteSection({ sectionId: msg.section_id }) })
  },
  methods: {
    ...mapActions('section', ['startEditingSection', 'showSectionActionMenu', 'deleteSection']),
    getAskToDeleteSectionManifest () {
      return nativeBridge.uiManifests.alert({
        title: this.__('Delete column'),
        body: this.__('Are you sure you want to delete this column and all its posts? This cannot be undone!'),
        buttons: [
          nativeBridge.uiManifests.button({
            name: this.__('Cancel'),
            action: {
              message_type: 'cancel_show'
            },
            style: 'cancel'
          }), nativeBridge.uiManifests.button({
            name: this.__('Delete'),
            action: {
              message_type: 'delete_section',
              section_id: this.section.id
            },
            style: 'destructive'
          })
        ],
        cancelAction: {
          message_type: 'cancel_show'
        },
        actionMessageType: 'ask_to_delete'
      })
    },
    getSectionMenuManifest () {
      let $sectionElem = $('.surface-section#section-' + this.section.id + ' .surface-section-title')

      let renameSectionMenuItem = menuItemBuilder({
        name: this.__('Rename column'),
        icon: 'edit_section',
        action: {
          message_type: 'edit_section',
          section_id: this.section.id
        }
      })
      let deleteSectionMenuItem = menuItemBuilder({
        name: this.__('Delete column'),
        icon: 'ask_to_delete',
        launches: $.extend(this.getAskToDeleteSectionManifest(this.section), {
          actionMessageType: 'ask_to_delete'
        })
      })
      return nativeBridge.uiManifests.alertSheet({
        title: '',
        element: nativeBridge.uiManifests.domElement($sectionElem),
        menuItems: [renameSectionMenuItem, deleteSectionMenuItem],
        cancelAction: {
          message_type: 'cancel_show'
        }
      })
    },
    showDropdown () {
      nativeBridge.ui.show('alert_sheet', this.getSectionMenuManifest(), () => {
        this.showSectionActionMenu({ sectionId: this.section.id })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.actions-dropdown {
  width: 40px;
  height: 40px;
  overflow: hidden;

  & > i {
    position: absolute;
    top: 4px;
    right: -3px;
  }
}
</style>
